import { CONTENT_ADD_INSTAGRAM_PAGE } from 'components/content-pool/constants'
import React from 'react'
import { IntegrationConfigRenderBase } from './integrationConfigRenderBase'

declare const RASA_SELF_SERVICE_API: string

export class InstagramConfigRender extends IntegrationConfigRenderBase {
  protected supportsFilter: boolean = false

  protected initializeCustomState(): Promise<void> {
    if (this.props.params.operation) {
      if (!this.props.params.operation.includes('Failure')) {
        if (this.props.params.ref) {
          this.props.push(this.props.params.ref)
        }
      }
    }
    return Promise.resolve()
  }

  protected renderDisconnect() {
    if (!!this.props.data.is_active) {
      return <div className="connect-disconnect-wrapper">
        <div className={'save-button clickable-item save-button-enabled disconnect'}
          onClick={(e) => this.disconnect()}>Disconnect
        </div>
      </div>
    }
  }

  protected buildPopUpUrl(): string {
    const systemName = this.props.data.systemName
    let state = `${this.encodedCommunityIdentifier}`
    state += btoa(`|${this.props.params.ref || CONTENT_ADD_INSTAGRAM_PAGE}`)

    return `${this.systemInfo.keyUrl}${state}&client_id=${this.props.clientIds[systemName]}&redirect_uri=${RASA_SELF_SERVICE_API}/integrations/${systemName.toLowerCase()}-oauth-callback`
  }
}
